import Axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../context';
import { ENDPOINT, ShowNotification } from '../utils/constants';
import Layout from './layout';
import "./styles/profile.css"
import Cookie from 'js-cookie'
import ProfileBox from './comps/profilebox';
import History from './comps/history';

export default function Profile() {
    const context = useContext(Context)
    const [userData, setUserData] = useState(null)
    const [history, setHistory] = useState(null)
    const [totalPoints, setTotalPoints] = useState(0)

    const handleLogout = () => {
        ShowNotification('Logging out..', 'red', -1)
        let token;
        token = Cookie.get("token")
        Axios.delete(ENDPOINT + '/auth/logout', { token })
            .then(res => {
                Cookie.remove('token')
                context.setIsLogedIn(false)
            })
            .catch(err => {

            })
    }
    const fetchProfileData = () => {
        ShowNotification("Loading....", "white", -1)
        Axios.post(ENDPOINT + "/user/profile/mine", { token: context.myToken })
            .then(res => {
                processData(res)

            })
            .catch(err => {
                ShowNotification("Something went wrong", "red", -1)
            })
    }

    const processData = (res) => {
        const { user, scoresWithProblem } = res.data

        console.log(scoresWithProblem)

        setUserData(user)
        setHistory(scoresWithProblem)
        let temp_points = 0
        scoresWithProblem.forEach(sp => {
            temp_points += sp.points
        })
        setTotalPoints(temp_points)

        ShowNotification("", "white", 1)
        context.setProfileData({ user, scoresWithProblem })

    }

    useEffect(() => {
        if (!context.profileData)
            fetchProfileData()
        else
            processData({ data: context.profileData })
    }, [])


    return (
        <Layout>
            <div className="pf-wrapper">
                {userData && <ProfileBox name={userData.name} profile_pic={userData.profile_pic} />}
                <div className="pf-logout" onClick={() => { handleLogout() }}>
                    Logout
                </div>
                {history && <History history={history} />}
            </div>
        </Layout>
    )
}